import request from 'superagent'
import moment  from 'moment';

//let url = `http://localhost:7071/api/monthEvents`
let url = `api/monthEvents`

export function getAllEvents (callback) {
  request
    .get(url)
    .end((err, resp) => {
      if (err) {console.log(err)}
      if (!err) {
        const roomEvents = [];
        JSON.parse(resp.text).map((roomEvent) => {
          let bookings = [];
          for (let i=0; i<roomEvent.bookings.length; i++){
            bookings.push(
              {start: moment(roomEvent.bookings[i].start),
                end: moment(roomEvent.bookings[i].end)
              }
            )
          }
          return roomEvents.push({
            room: roomEvent.room,
            bookings: bookings
          })
        })
        callback(roomEvents);
      }
    })
    return;
}

export function getMonthEvents (dateString, callback) {
  request
    .get(url+ "/" + dateString)
    .end((err, resp) => {
      if (err) {console.log(err)}
      if (!err) {
        const roomEvents = [];
        JSON.parse(resp.text).map((roomEvent) => {
          let bookings = [];
          for (let i=0; i<roomEvent.bookings.length; i++){
            bookings.push(
              {start: moment(roomEvent.bookings[i].start),
                end: moment(roomEvent.bookings[i].end)
              }
            )
          }
          return roomEvents.push({
            room: roomEvent.room,
            bookings: bookings
          })
          
        })
        callback(roomEvents);
      }
    })

}


// WEBPACK FOOTER //
// ./src/EventsProvider.js